"use strict";
// @ts-ignore
try {
    self['workbox:range-requests:6.4.1'] && _();
}
catch (e) { }
